/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-12-09 18:35:56
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-10 14:31:26
 */
/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-08-17 20:29:38
 * @LastEditors: voanit
 * @LastEditTime: 2021-09-08 14:01:18
 */
export default [
  {
    path: '/rbac',
    name: 'rbac-manager',
    meta: {
      name: '角色权限管理',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "managemement" */'@/views/system-manager/rbac/index.vue')
  },
  {
    path: '/exchange-manager',
    name: 'exchange-manager',
    meta: {
      name: '汇率设置',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "managemement" */'@/views/system-manager/exchange/index.vue')
  },
  {
    path: '/team-manager',
    name: 'team-manager',
    meta: {
      name: '员工管理',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "managemement" */'@/views/system-manager/team/index.vue')
  },
  {
    path: '/watermark-manager',
    name: 'watermark-manager',
    meta: {
      name: '水印管理',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "managemement" */'@/views/system-manager/watermark-manager/index.vue')
  },
  {
    path: '/enterprise-manager',
    name: 'enterprise-manager',
    meta: {
      name: '企业管理',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "managemement" */'@/views/system-manager/enterprise-manager/index.vue')
  },
]
